// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-page {
  width: 100vw;
  height: 100vh;
}
.chat-bg1 {
  position: fixed;
  top: 0;
  left: 0;
  width: inherit;
  height: inherit;
}
/* .chat-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
} */
.bg {
  /* width: 100%;
  height: 100%;
  object-fit: cover; */
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.bgobc{
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.chat-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  /* height: 50vh; */
  height: 58vh;
  padding: 16px 0;
  box-sizing: border-box;
}
.message-list {
  flex: 1 1;
  padding: 0 16px;
  overflow: auto;
}
.message-list .message-item {
  /* width: 100%; */
  width: calc(100vw - 32px);
  font-size: 12px;
  white-space: pre-wrap;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  /* user-select: none; */
}
.message-list .message-item:last-child {
  margin-bottom: 0px !important;
}
.message-list .ai {
  /* position: relative;
  padding: 18px;
  background: rgba(61, 70, 174, 0.84) !important;
  border-radius: 0px 20px 20px 20px !important;
  margin-bottom: 16px;
  display: inline-block;
  width: 287px;
  font-size: 16px;
  font-family: Helvetica, Helvetica;
  font-weight: 400;
  color: white;
  line-height: 20px; */

  position: relative;
  padding: 18px;
  background: rgba(61, 70, 174, 0.84) !important;
  border-radius: 0px 20px 20px 20px !important;
  margin-bottom: 16px;
  /* flex: 1; */
  display: inline-block;
  width: 370px;
  font-size: 24px;
  font-family: Helvetica, Helvetica;
  font-weight: 400;
  color: white;
  line-height: 34px;
  /* user-select: none; */
  /* user-select: none; */
}
.message-list .user {
  /* background: linear-gradient(
    55deg,
    rgba(232, 204, 254, 0.9) 28.69%,
    rgba(172, 205, 255, 0.9) 90.93%
  ) !important;
  border-radius: 10px 10px 0 10px !important;
  font-size: 16px;
  line-height: 27px;
  padding: 17px 17px;
  padding-right: 43px; */
  /* width: 287px; */
  width: 370px;
  padding: 18px;
  border-radius: 20px 0px 20px 20px !important;
  background: linear-gradient(
    141.14deg,
    rgba(163, 69, 237, 0.87) 0%,
    rgba(125, 82, 216, 0.87) 100%
  ) !important;
  /* font-size: 13px; */
  font-size: 24px;
  font-family: Helvetica, Helvetica;
  font-weight: 400;
  color: white;
  line-height: 34px;
  /* float: left; */
  margin-left: 130px;
  /* margin-right: 20px; */
  /* user-select: none; */
}
.send-button {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 239px;
  height: 48px;
  font-size: 18px;
  font-weight: 400;
  background: linear-gradient(
    68deg,
    rgba(154, 195, 255, 0.9) 37.12%,
    rgba(255, 113, 224, 0.9) 69.43%
  );
  margin-top: 16px;
  border-radius: 48px;
  margin-bottom: 30px;
  -webkit-user-select: none;
          user-select: none;
}
.send-button-disabled {
  color: #999999;
  background: #dddddd !important;
  -webkit-user-select: none;
          user-select: none;
}
.record-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
}
.record-container .record-icon {
  height: 56px;
}
.record-container .record-icon img {
  height: 100%;
}
.record-container .record-tip {
  font-size: 12px;
  color: #cccccc;
  margin-top: 134px;
  margin-bottom: 34px;
}
.record-container .record-button {
  position: relative;
  width: 100%;
}
.record-container .record-button > img {
  width: 100%;
}
.record-container .shengbo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 22px;
}
.record-container .shengbo > img {
  width: 100%;
}
.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.4);
}
.bottom-safe-area {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}
.prologue {
  width: 80%;
  background: rgba(6, 11, 25, 0.78);
  border-radius: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  padding: 14px;
  margin-bottom: 16px;
}
.prologue-name {
  color: white;
}
.prologue-slogan {
  color: #c0ffff;
}
.content {
  position: relative;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
}
.left-cont {
  width: 38%;
  position: relative;
  display: flex;
  justify-content: center;
}
.left-people {
  width: 53%;
  position: absolute;
  bottom: 171px;
}
.left-wu {
  width: 100%;
  position: absolute;
  bottom: 73px;
  height: 474px;
}
.left-foot {
  width: 80%;
  position: absolute;
  bottom: 0;
  height: 213px;
}
.right-cont {
  flex: 1 1;
  position: relative;
}
.talk-box {
  width: 286px;
  height: 80px;
  /* margin-top: 82px; */
  position: absolute;
  bottom: 42px;
  margin-left: 82px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.talk-ball {
  width: 92px;
  cursor: pointer;
}
.sum-right {
  width: 252px;
  margin-left: 32px;
}
.message-box {
  /* width: 520px; */
  width: 600px;
  /* width: 440px; */
  /* height: 429px; */
  /* height: 520px; */
  /* height: 60%; */
  height: 70%;
  /* margin-top: 40px; */
  overflow: auto;
  position: absolute;
  top: 70px;
}
.none-btn {
  display: none;
}
.ai-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 14px;
  float: left;
}
.user-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-left: 14px;
  /* float: right; */
}
.cancal-record {
  width: 40px;
  height: 40px;
  margin-right: 17px;
  cursor: pointer;
}
.send-record {
  width: 61px;
  margin-right: 17px;
  cursor: pointer;
}
.sayz-record {
  width: 143px;
}
.talk-bottom {
  position: absolute;
  width: 51px;
  bottom: 30px;
  right: 35px;
  cursor: pointer;
}
.mask-talk {
  width: 405px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 1;
  background: rgba(15, 18, 56, 0.89);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.mask-talk-box {
  width: 100%;
  height: 50%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
}
.talk-list {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  cursor: pointer;
}
.close-talk {
  width: 51px;
  position: absolute;
  right: 35px;
  bottom: 30px;
  /* height: 51px; */
  cursor: pointer;
}
.talk-list p {
  position: absolute;
  color: rgba(193, 204, 255, 1);
  text-align: center;
  font-size: 22px;
}
.talk-img {
  width: 320px;
}
.sum-right {
  width: 252px;
  margin-left: 32px;
}
.talk-bottom {
  position: absolute;
  width: 51px;
  bottom: 30px;
  right: 35px;
  cursor: pointer;
}
.message-boxer {
  margin-top: 20px;
  display: flex;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/jintaiyang/mobile.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,eAAe;AACjB;AACA;;;;GAIG;AACH;EACE;;sBAEoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;;;;;;;;;;;sBAWoB;;EAEpB,kBAAkB;EAClB,aAAa;EACb,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE;;;;;;;;;wBASsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C;;;;cAIY;EACZ,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB;;;;GAIC;EACD,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,gDAAgD;EAChD,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;AACA;EACE,SAAO;EACP,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb","sourcesContent":[".mobile-page {\n  width: 100vw;\n  height: 100vh;\n}\n.chat-bg1 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: inherit;\n  height: inherit;\n}\n/* .chat-bg img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n} */\n.bg {\n  /* width: 100%;\n  height: 100%;\n  object-fit: cover; */\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n}\n.bgobc{\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.4);\n}\n.chat-container {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100vw;\n  /* height: 50vh; */\n  height: 58vh;\n  padding: 16px 0;\n  box-sizing: border-box;\n}\n.message-list {\n  flex: 1 1;\n  padding: 0 16px;\n  overflow: auto;\n}\n.message-list .message-item {\n  /* width: 100%; */\n  width: calc(100vw - 32px);\n  font-size: 12px;\n  white-space: pre-wrap;\n  padding: 10px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  /* user-select: none; */\n}\n.message-list .message-item:last-child {\n  margin-bottom: 0px !important;\n}\n.message-list .ai {\n  /* position: relative;\n  padding: 18px;\n  background: rgba(61, 70, 174, 0.84) !important;\n  border-radius: 0px 20px 20px 20px !important;\n  margin-bottom: 16px;\n  display: inline-block;\n  width: 287px;\n  font-size: 16px;\n  font-family: Helvetica, Helvetica;\n  font-weight: 400;\n  color: white;\n  line-height: 20px; */\n\n  position: relative;\n  padding: 18px;\n  background: rgba(61, 70, 174, 0.84) !important;\n  border-radius: 0px 20px 20px 20px !important;\n  margin-bottom: 16px;\n  /* flex: 1; */\n  display: inline-block;\n  width: 370px;\n  font-size: 24px;\n  font-family: Helvetica, Helvetica;\n  font-weight: 400;\n  color: white;\n  line-height: 34px;\n  /* user-select: none; */\n  /* user-select: none; */\n}\n.message-list .user {\n  /* background: linear-gradient(\n    55deg,\n    rgba(232, 204, 254, 0.9) 28.69%,\n    rgba(172, 205, 255, 0.9) 90.93%\n  ) !important;\n  border-radius: 10px 10px 0 10px !important;\n  font-size: 16px;\n  line-height: 27px;\n  padding: 17px 17px;\n  padding-right: 43px; */\n  /* width: 287px; */\n  width: 370px;\n  padding: 18px;\n  border-radius: 20px 0px 20px 20px !important;\n  background: linear-gradient(\n    141.14deg,\n    rgba(163, 69, 237, 0.87) 0%,\n    rgba(125, 82, 216, 0.87) 100%\n  ) !important;\n  /* font-size: 13px; */\n  font-size: 24px;\n  font-family: Helvetica, Helvetica;\n  font-weight: 400;\n  color: white;\n  line-height: 34px;\n  /* float: left; */\n  margin-left: 130px;\n  /* margin-right: 20px; */\n  /* user-select: none; */\n}\n.send-button {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 239px;\n  height: 48px;\n  font-size: 18px;\n  font-weight: 400;\n  background: linear-gradient(\n    68deg,\n    rgba(154, 195, 255, 0.9) 37.12%,\n    rgba(255, 113, 224, 0.9) 69.43%\n  );\n  margin-top: 16px;\n  border-radius: 48px;\n  margin-bottom: 30px;\n  user-select: none;\n}\n.send-button-disabled {\n  color: #999999;\n  background: #dddddd !important;\n  user-select: none;\n}\n.record-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 3;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.6);\n}\n.record-container .record-icon {\n  height: 56px;\n}\n.record-container .record-icon img {\n  height: 100%;\n}\n.record-container .record-tip {\n  font-size: 12px;\n  color: #cccccc;\n  margin-top: 134px;\n  margin-bottom: 34px;\n}\n.record-container .record-button {\n  position: relative;\n  width: 100%;\n}\n.record-container .record-button > img {\n  width: 100%;\n}\n.record-container .shengbo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 22px;\n}\n.record-container .shengbo > img {\n  width: 100%;\n}\n.loading-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 4;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(255, 255, 255, 0.4);\n}\n.bottom-safe-area {\n  padding-bottom: constant(safe-area-inset-bottom);\n  padding-bottom: env(safe-area-inset-bottom);\n}\n.prologue {\n  width: 80%;\n  background: rgba(6, 11, 25, 0.78);\n  border-radius: 20px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 14px;\n  margin-bottom: 16px;\n}\n.prologue-name {\n  color: white;\n}\n.prologue-slogan {\n  color: #c0ffff;\n}\n.content {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n}\n.left-cont {\n  width: 38%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n.left-people {\n  width: 53%;\n  position: absolute;\n  bottom: 171px;\n}\n.left-wu {\n  width: 100%;\n  position: absolute;\n  bottom: 73px;\n  height: 474px;\n}\n.left-foot {\n  width: 80%;\n  position: absolute;\n  bottom: 0;\n  height: 213px;\n}\n.right-cont {\n  flex: 1;\n  position: relative;\n}\n.talk-box {\n  width: 286px;\n  height: 80px;\n  /* margin-top: 82px; */\n  position: absolute;\n  bottom: 42px;\n  margin-left: 82px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.talk-ball {\n  width: 92px;\n  cursor: pointer;\n}\n.sum-right {\n  width: 252px;\n  margin-left: 32px;\n}\n.message-box {\n  /* width: 520px; */\n  width: 600px;\n  /* width: 440px; */\n  /* height: 429px; */\n  /* height: 520px; */\n  /* height: 60%; */\n  height: 70%;\n  /* margin-top: 40px; */\n  overflow: auto;\n  position: absolute;\n  top: 70px;\n}\n.none-btn {\n  display: none;\n}\n.ai-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-right: 14px;\n  float: left;\n}\n.user-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-left: 14px;\n  /* float: right; */\n}\n.cancal-record {\n  width: 40px;\n  height: 40px;\n  margin-right: 17px;\n  cursor: pointer;\n}\n.send-record {\n  width: 61px;\n  margin-right: 17px;\n  cursor: pointer;\n}\n.sayz-record {\n  width: 143px;\n}\n.talk-bottom {\n  position: absolute;\n  width: 51px;\n  bottom: 30px;\n  right: 35px;\n  cursor: pointer;\n}\n.mask-talk {\n  width: 405px;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  opacity: 1;\n  background: rgba(15, 18, 56, 0.89);\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n.mask-talk-box {\n  width: 100%;\n  height: 50%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.talk-list {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  align-items: center;\n  cursor: pointer;\n}\n.close-talk {\n  width: 51px;\n  position: absolute;\n  right: 35px;\n  bottom: 30px;\n  /* height: 51px; */\n  cursor: pointer;\n}\n.talk-list p {\n  position: absolute;\n  color: rgba(193, 204, 255, 1);\n  text-align: center;\n  font-size: 22px;\n}\n.talk-img {\n  width: 320px;\n}\n.sum-right {\n  width: 252px;\n  margin-left: 32px;\n}\n.talk-bottom {\n  position: absolute;\n  width: 51px;\n  bottom: 30px;\n  right: 35px;\n  cursor: pointer;\n}\n.message-boxer {\n  margin-top: 20px;\n  display: flex;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
